import axios from 'axios';

// Dedicated axios client for the vendor portal. Completely separate from the
// staff client: its own token storage keys, no staff /auth refresh, and it
// redirects to the vendor login (never the staff login) on auth failure.

export const VENDOR_TOKEN_KEY = 'vendor_accessToken';
export const VENDOR_REFRESH_KEY = 'vendor_refreshToken';
export const VENDOR_INFO_KEY = 'vendor_info';

export const serverURL = process.env.REACT_APP_BASE_URL || 'http://143.110.243.16:4000';

export const vendorImagePath = (path: string) => {
	if (!path) return '';
	if (path.startsWith('http://') || path.startsWith('https://')) return path;
	return `${serverURL}/${path.replace(/^\//, '')}`;
};

const vendorAxios = axios.create({
	baseURL: serverURL,
	headers: { 'Content-Type': 'application/json' },
});

vendorAxios.interceptors.request.use((config) => {
	const token = localStorage.getItem(VENDOR_TOKEN_KEY);
	if (token) {
		config.headers.Authorization = `Bearer ${token}`;
	}
	return config;
});

vendorAxios.interceptors.response.use(
	(response) => response,
	(error) => {
		const status = error?.response?.status;
		const msg = error?.response?.data?.message?.toLowerCase?.() || '';
		if (status === 401 || msg.includes('token') || msg.includes('authoris')) {
			// Vendor session is invalid — clear vendor keys and bounce to vendor login.
			localStorage.removeItem(VENDOR_TOKEN_KEY);
			localStorage.removeItem(VENDOR_REFRESH_KEY);
			localStorage.removeItem(VENDOR_INFO_KEY);
			if (!window.location.pathname.includes('/vendor-portal/login')) {
				window.location.href = '/vendor-portal/login';
			}
		}
		return Promise.reject(error);
	},
);

export default vendorAxios;
